import React from 'react';
import { Modal, Button } from '../ui';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  timeRemaining: number;
  onExtendSession: () => void;
  onLogout: () => void;
}

const formatTimeRemaining = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes > 0) {
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
  return `${seconds} seconds`;
};

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  isOpen,
  timeRemaining,
  onExtendSession,
  onLogout,
}) => (
    <Modal
      isOpen={isOpen}
      onClose={onExtendSession}
      title="Session Expiring Soon"
      size="sm"
      closeOnOverlayClick={false}
      closeOnEscape={false}
      showCloseButton={false}
      footer={
        <>
          <Button variant="ghost" onClick={onLogout}>
            Log Out
          </Button>
          <Button variant="primary" onClick={onExtendSession}>
            Stay Logged In
          </Button>
        </>
      }
    >
      <div className="text-center py-4">
        {/* Warning Icon */}
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-au-warning-lightest mb-4">
          <svg
            className="w-8 h-8 text-au-warning"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Message */}
        <p className="text-au-text-secondary mb-4">
          Your session will expire soon due to inactivity. Would you like to stay logged in?
        </p>

        {/* Countdown */}
        <div className="bg-au-surface-sunken rounded-au-base p-3">
          <span className="text-sm text-au-text-tertiary">Time remaining: </span>
          <span className="text-lg font-semibold text-au-warning">
            {formatTimeRemaining(timeRemaining)}
          </span>
        </div>
      </div>
    </Modal>
  );

export default SessionTimeoutModal;
